import { render, staticRenderFns } from "./mintage.vue?vue&type=template&id=6cc81986&scoped=true&"
import script from "./mintage.vue?vue&type=script&lang=js&"
export * from "./mintage.vue?vue&type=script&lang=js&"
import style0 from "./mintage.vue?vue&type=style&index=0&id=6cc81986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc81986",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cc81986')) {
      api.createRecord('6cc81986', component.options)
    } else {
      api.reload('6cc81986', component.options)
    }
    module.hot.accept("./mintage.vue?vue&type=template&id=6cc81986&scoped=true&", function () {
      api.rerender('6cc81986', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/mintage/mintage.vue"
export default component.exports